var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.998535,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "#1F72CD",
    stroke: "#E4EBF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68111 8.99854L3.5 16.2453H7.30824L7.78035 15.0898H8.85949L9.3316 16.2453H13.5234V15.3634L13.8969 16.2453H16.0652L16.4387 15.3448V16.2453H25.1566L26.2166 15.1199L27.2092 16.2453L31.6868 16.2546L28.4957 12.6421L31.6868 8.99854H27.2786L26.2467 10.1032L25.2854 8.99854H15.8016L14.9872 10.869L14.1537 8.99854H10.3534V9.85039L9.93068 8.99854H6.68111ZM19.6994 10.0276H24.7055L26.2367 11.7302L27.8172 10.0276H29.3484L27.0219 12.6411L29.3484 15.2245H27.7477L26.2166 13.5022L24.628 15.2245H19.6994V10.0276ZM20.9356 12.0535V11.1042V11.1033H24.0593L25.4223 12.6214L23.9989 14.1479H20.9356V13.1115H23.6667V12.0535H20.9356ZM7.41799 10.0276H9.2743L11.3843 14.9416V10.0276H13.4178L15.0476 13.5509L16.5496 10.0276H18.573V15.2276H17.3418L17.3317 11.1529L15.5368 15.2276H14.4355L12.6305 11.1529V15.2276H10.0977L9.61756 14.0618H7.02338L6.54421 15.2266H5.18717L7.41799 10.0276ZM7.46634 12.9841L8.32101 10.9074L9.1747 12.9841H7.46634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard02);
export default __webpack_public_path__ + "static/media/card-02.0311eb741a9268dfd0257cd61f4ede85.svg";
export { ForwardRef as ReactComponent };